'use strict';
import React, { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { ACCESS_MANAGEMENT, HGT, LEGAL_AGREEMENTS, PIPELINE_TRACKER } from '@/views/routes';
import './UserOptions.scss';
import { useAuth } from '@/hooks/auth.hook';
import { useAuth0 } from '@auth0/auth0-react';
import * as enums from '@/enums/Enums';
import { useLocalAuditLogger } from "@/hooks/useLocalAuditLogger";
import { usePermissions } from "@/hooks/permissions.hook";
import * as permissions from '@/security/permissionTypes';
import { useLogout } from '@/contexts/LogoutContext';
import { Box } from '@mui/material';
import { ENABLE_PIPELINE_STATUS } from '@/config/env.config';

export const UserOptions = (props) => {

	const [isBasic, setIsBasic] = useState(false);
	const logger = useLocalAuditLogger();
	const auth = useAuth();
	const { setIsLoggingOut } = useLogout();
	const { getAccessTokenSilently } = useAuth0();
	const history = useHistory();
	const { checkUserHasPermissions, checkUserHasRole } = usePermissions();

	const canViewAdmin = checkUserHasPermissions(permissions.CAN_VIEW_ADMIN);
	const canEditUsers = checkUserHasPermissions(permissions.CAN_EDIT_USERS);

	useEffect(() => {
		let basicRole = checkUserHasRole(enums.ROLES.BASIC);
		setIsBasic(basicRole);
	}, [checkUserHasRole]);

	const accessManagementClickHandler = useCallback(() => {
		history.push(`/home/${ACCESS_MANAGEMENT}`);
	}, [history]);

	const pipelineTrackerClickHandler = useCallback(() => {
		history.push(`/home/${PIPELINE_TRACKER}`);
	}, [history]);

	const hgtClickHandler = useCallback(() => {
		history.push(`/home/${HGT}`);
	}, [history]);

	const legalAgreementsClickHandler = useCallback(() => {
		history.push(`/home/${LEGAL_AGREEMENTS}`);
	}, [history]);

	const signOutClickHandler = useCallback(async () => {
		setIsLoggingOut(true);
		// Get token for audit logging before logout (best-effort only)
		try {
			const token = await getAccessTokenSilently({
				audience: 'https://portal-api'
			});
			logger.logOutUser(enums.AUDITLOG_USERACTION_TYPES.LOGOUT, token);
		} catch (error) {
			// Ignore audit logging failures and continue logout.
		}
		auth.logout('/');
	}, [auth, logger, getAccessTokenSilently, setIsLoggingOut]);


	return (
		<Box visibility={props.visible ? 'visible' : 'hidden'} className={"UserOptionsContainer"}>
			<div>{props.username}</div>
			<div>{props.email}</div>
			<hr />
			{canViewAdmin && <div className="hgt" onClick={hgtClickHandler}>HGT</div>}
			{canEditUsers && <div className="access-management" onClick={accessManagementClickHandler}>Access Management</div>}
			{canViewAdmin && ENABLE_PIPELINE_STATUS && <div className="pipeline-status-admin" onClick={pipelineTrackerClickHandler}>Pipeline Status</div>}
			{isBasic && <div className="legal-agreements" onClick={legalAgreementsClickHandler}>Legal Agreements</div>}
			<hr />
			<div className="signout" onClick={signOutClickHandler}>Sign Out</div>
		</Box>
	);
};

export default UserOptions;